import { render, staticRenderFns } from "./DrawingOpinionView.vue?vue&type=template&id=77d970f0&scoped=true"
import script from "./DrawingOpinionView.vue?vue&type=script&lang=js"
export * from "./DrawingOpinionView.vue?vue&type=script&lang=js"
import style0 from "./DrawingOpinionView.vue?vue&type=style&index=0&id=77d970f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d970f0",
  null
  
)

export default component.exports